import Image from "next/image";
import { partnerImageDimensions } from "@/constants/hero/imageDimensions";
import { cn } from "@/lib/utils";
import useTranslations from "@/i18n/useTranslations";

export interface PartnershipDescriptionProps {
  title?: string | null;
  prePartnerText?: string;
  postPartnerText?: string;
  partnerLogoList: string[];
  partnerNameList: string[];
  partnerLogoOverride?: string;
  titleClassName?: string;
}

const PartnershipDescription = ({
  title,
  prePartnerText,
  postPartnerText,
  partnerLogoList = [],
  partnerNameList = [],
  partnerLogoOverride,
  titleClassName = "",
}: PartnershipDescriptionProps) => {
  const t = useTranslations("Common");
  const resolvedTitle = title ?? t("powerfulPartnership");
  const resolvedPrePartnerText =
    prePartnerText ?? t("edxPartnersWithPrestigiousInstitutions");
  const resolvedPostPartnerText =
    postPartnerText ?? t("thatShareOurCommitment");
  let partnerText = `${partnerNameList.join(", ")}`;
  return (
    <div className="flex justify-center items-center">
      <div className="flex flex-col sm:flex-row gap-4 md:gap-12">
        <div className="flex flex-row gap-6 border-2 px-6 py-6 bg-white rounded-xl flex-shrink-0 justify-center items-center">
          {partnerLogoList.length > 1 && !partnerLogoOverride ? (
            <div className="flex flex-col gap-2 justify-center items-center">
              {partnerLogoList.map((image, i) => (
                <Image
                  src={image}
                  alt={t("partnerAlt")}
                  width={220}
                  height={partnerImageDimensions.height}
                  key={`${image}-${i}`}
                />
              ))}
              <div className="bg-putty-300 w-full h-0.5"></div>
              <Image
                src={"/trademark-logos/edx-logo-elm.svg"}
                alt={"edX Modal Logo"}
                title="edX"
                width={90}
                height={90}
                className="mt-1"
              />
            </div>
          ) : null}

          {partnerLogoList.length === 1 || partnerLogoOverride
            ? partnerLogoList.map((image, i) => (
                <>
                  <Image
                    src={image}
                    alt={t("partnerAlt")}
                    width={partnerImageDimensions.width}
                    height={partnerImageDimensions.height}
                    key={`${image}-${i}`}
                  />
                  <div className="border h-32"></div>
                  <Image
                    src={"/trademark-logos/edx-logo-elm.svg"}
                    alt={"edX Modal Logo"}
                    title="edX"
                    width={90}
                    height={90}
                  />
                </>
              ))
            : null}
        </div>

        <div className="flex justify-center items-start  flex-col gap-4 flex-1 min-w-[200px]">
          <h3 className={cn("text-2xl font-bold m-0", titleClassName)}>
            {resolvedTitle}
          </h3>
          <p className="m-0 text-base break-words text-primary-500">
            {resolvedPrePartnerText}{" "}
            <span className="font-bold">{partnerText}</span>{" "}
            {resolvedPostPartnerText}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PartnershipDescription;
